export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/environments/environment.ts